export enum ErrorCodes {
  InternalError = 500,
  success = 200,
  UnAuthorized = 401,
}

export enum ErrorTypes {
  Unhandled = "unhandled",
  Validation = "validation",
}
export enum Gender {
  Male = "Male",
  Female = "Female",
  Other = "Other",
}
export enum ApplicationStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Canceled = "Canceled",
}

export enum RequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
}


export enum Status {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  cancelled = "Cancelled",
}


export enum Level {
  Matriculation = "Matriculation",
  HSC = "HSC",
  UG = "UG",
  PG = "PG",
  Other = "Other",
}

export enum JobType {
  Internal = "Internal",
  External = "External",
}
export enum JobStatus {
  Draft = "Draft",
  Published = "Published",
  Closed = "Closed",
}
export enum EmploymentType {
  FullTime = "Full Time",
  PartTime = "Part Time",
  Contract = "Contract",
}
export enum JobApplicationStatus {
  Pending = "Pending",
  ShortListed = "ShortListed",
  Rejected = "Rejected",
}

export enum CompanyType {
  Public = "Public",
  Private = "Private",
  LLP = "LLP",
}

export enum QualificationType {
  Graduation = "Graduation",
  PostGraduation = "Post Graduation",
  Certification = "Certification",
  Diploma = "Diploma",
  Other = "Other",
}


